const fontColor = '#333'
const mainColor = '#2f6894'
const highlightColor = '#eb6600'
const darkHighlightColor = '#d05d03'
const buttonColor = '#fff'
const buttonBackgroundColor = '#00467f'
const buttonBorderColor = '#00325c'

const buttonStyles = {
  color: buttonColor,
  background: buttonBackgroundColor,
  border: buttonBorderColor,
  hover: {
    background: highlightColor,
    border: darkHighlightColor
  }
}

export default {
  name: 'centrum',
  header: {
    logo: {
      bottom: 10,
      height: 30
    },
    search: {
      sections: {
        color: '#949494',
        activeColor: highlightColor
      },
      form: {
        autocomplete: {
          color: highlightColor
        },
        input: {
          borderColor: mainColor,
          borderColorFocus: highlightColor,
          color: fontColor
        }
      }
    },
    email: {
      indicatorColor: highlightColor,
      linkColor: mainColor
    }
  },
  dynamicLead: {
    firstBox: {
      backgroundColor: buttonBackgroundColor,
      backgroundColorHover: buttonBorderColor,
      color: 'white'
    },
    smallBox: {
      color: fontColor
    }
  },
  mobileTabs: {
    background: '#edf2f6'
  },
  email: {
    summary: {
      background: '#edf2f6',
      registrationLink: {
        color: mainColor,
        colorHover: highlightColor
      },
      checkbox: {
        colorChecked: darkHighlightColor
      },
      submit: {
        color: buttonColor,
        border: buttonBorderColor,
        borderRadius: '0 4px 4px 0',
        background: buttonBackgroundColor,
        borderHover: darkHighlightColor,
        backgroundHover: highlightColor
      },
      input: {
        border: '#d2d2d2',
        borderFocus: highlightColor,
        borderRadius: '0'
      }
    },
    full: {
      color: mainColor,
      subject: {
        color: mainColor,
        colorHover: highlightColor
      },
      toggleIcon: {
        background: `${STATICS_PATH}images/email/arrow-centrum.png`
      }
    }
  },
  weather: {
    button: buttonStyles
  },
  exchange: {
    button: buttonStyles
  },
  tip: {
    background: '#949494',
    color: '#fff'
  },
  footer: {
    color: fontColor,
    colorLink: fontColor
  },
  services: {
    color: mainColor
  },
  jobs: {
    arrowUrl: `${STATICS_PATH}images/jobs/arrow-centrum.png`,
    color: mainColor,
    colorHover: highlightColor
  },
  newsfeed: {
    button: buttonStyles
  },
  headline: {
    color: mainColor,
    colorHover: highlightColor
  },
  moreLink: {
    color: mainColor,
    colorHover: highlightColor
  },
  link: {
    colorHover: highlightColor
  },
  featured: {
    video: {
      backgroundColor: buttonBackgroundColor,
      borderColor: buttonBorderColor,
      color: buttonColor,
      iconInvert: '0%'
    }
  },
  button: buttonStyles
}
